import { App as vueApp, createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router /* , { offlineRouter } */ from "./router";
import { store } from "./store";
import RankIcon from "./components/RankIcon.vue";

import "@popperjs/core";
import "bootstrap";
import "./assets/styles/flags.scss";
import "./assets/styles/custom-bootstrap.scss";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../node_modules/@fortawesome/fontawesome-pro/css/solid.css";
import "../node_modules/@fortawesome/fontawesome-pro/css/sharp-solid.css";
import "../node_modules/@fortawesome/fontawesome-pro/css/regular.css";
import "../node_modules/@fortawesome/fontawesome-pro/css/light.css";
import "../node_modules/@fortawesome/fontawesome-pro/css/brands.css";
import "../node_modules/@fortawesome/fontawesome-pro/css/fontawesome.css";
import "../node_modules/cropperjs/dist/cropper.min.css";

const app: vueApp<Element> = createApp(App);
const pinia = createPinia();

app.component("RankIcon", RankIcon);

app
  .use(pinia)
  .use(store)
  .use(router)
  //.use(offlineRouter)
  .mount("#app");
